import React, { useEffect, useState } from "react";

import FilterPopoverPortal from "./FilterPopoverPortal";

interface ColumnTextFilterPopoverProps {
  columnId: string;
  title: string;
  value: string;
  onApply: (value: string) => void;
  onClear: () => void;
  onClose: () => void;
}

const ColumnTextFilterPopover: React.FunctionComponent<
  ColumnTextFilterPopoverProps
> = ({ columnId, title, value, onApply, onClear, onClose }) => {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleApply = () => {
    onApply(text.trim());
    onClose();
  };

  const handleClear = () => {
    onClear();
    onClose();
  };

  return (
    <FilterPopoverPortal>
      <div className="popover-header">
        <span className="popover-title">{title}</span>
        <button type="button" className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="popover-body">
        <div className="text-filter-input-wrap">
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="text-filter-input"
            aria-label={`${columnId}-text-filter`}
          />
        </div>
      </div>
      <div className="popover-footer">
        <button type="button" className="clear-btn" onClick={handleClear}>
          クリア
        </button>
        <button type="button" className="apply-btn" onClick={handleApply}>
          適用
        </button>
      </div>
    </FilterPopoverPortal>
  );
};

export default ColumnTextFilterPopover;
